import { useContext } from "react";

import { SendToPanelContext } from "./SendToPanelContext";

export function useSendToPanel() {
  const context = useContext(SendToPanelContext);
  if (!context) {
    throw new Error("useSendToPanel must be used within a SendToPanelProvider");
  }
  return context;
}
